// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__TZVtI","footer":"ModalInfo_footer__2o1F8"};